module.exports = __webpack_public_path__ + "static/media/Boletapago1.850974d3.png";